<template>
	<div class="headCss">
		<div class="head-time" v-if="languageCheck == 'English'">
			<span v-if="newTime.getDay() == 0">Sunday</span>
			<span v-else-if="newTime.getDay() == 1">Monday</span>
			<span v-else-if="newTime.getDay() == 2">Tuesday</span>
			<span v-else-if="newTime.getDay() == 3">Wednesday</span>
			<span v-else-if="newTime.getDay() == 4">Thursday</span>
			<span v-else-if="newTime.getDay() == 5">Friday</span>
			<span v-else-if="newTime.getDay() == 6">Saturday</span>
			<span style="margin: 0 0.2vw;">,{{ newTime.getMonth()+1 }}/{{ newTime.getDate() }}/{{ newTime.getFullYear() }}</span>
			<span>{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}</span> <span style="margin-left: 0.2vw;"> {{ newTime.getHours() > 12 ? 'PM' : 'AM' }} </span>
		</div>
		<div class="head-time" v-else>
			<span style="margin-right: 5px;">{{newTime.getFullYear()}}-{{newTime.getMonth() + 1}}-{{ newTime.getDate() < 10 ? '0' + newTime.getDate() : newTime.getDate()}}</span>
			<span v-if="newTime.getDay() == 0">星期日</span>
			<span v-else-if="newTime.getDay() == 1">星期一</span>
			<span v-else-if="newTime.getDay() == 2">星期二</span>
			<span v-else-if="newTime.getDay() == 3">星期三</span>
			<span v-else-if="newTime.getDay() == 4">星期四</span>
			<span v-else-if="newTime.getDay() == 5">星期五</span>
			<span v-else-if="newTime.getDay() == 6">星期六</span>
			<span style="margin-left: 4px;">{{ cithData.weather }}</span>
			<span style="margin-left: 5px;">{{ newTime.getHours() < 10 ? '0' + newTime.getHours() : newTime.getHours() }}:{{ newTime.getMinutes() < 10 ? '0' + newTime.getMinutes() : newTime.getMinutes() }}:{{ newTime.getSeconds() < 10 ? '0' + newTime.getSeconds() : newTime.getSeconds() }}</span>
		</div>
		<div class="head-out">
			<el-popover
				placement="bottom"
				trigger="click"
				popper-class="popoverBackB"
			>
				<div>
					<div :class="languageCheck == 'Chinese' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('Chinese')" >
						简体中文（CN）
						<i v-if="languageCheck == 'Chinese'" class="el-icon-check" style="color: white;"></i>
					</div>
					<div :class="languageCheck == 'Traditional' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('Traditional')">
						繁体中文（TC）
						<i v-if="languageCheck == 'Traditional'" class="el-icon-check" style="color: white;"></i>
					</div>
					<div :class="languageCheck == 'English' ? 'lenDom lenDomCheck' : 'lenDom'" @click="checkLanguage('English')">
						英文（English）
						<i v-if="languageCheck == 'English'" class="el-icon-check" style="color: white;"></i>
					</div>
				</div>
				<img class="out-img" slot="reference" :src="require('../../static/imgV2/English.png')" alt="">
			</el-popover>
			<div v-if="!tapStatus" @click="fullScreenHandle()">
				<img class="out-img" :src="openImg" alt="">
			</div>
			<div v-else @click="fullScreenHandle()">
				<img class="out-img" :src="closeImg" alt="">
			</div>
			<div @click="out()">
				<img class="out-cloes" :src="outImg" alt="">
			</div>
		</div>
		<img :src="headImg" style="width: 100%;" id="imgDom" alt="">
		<div :class="languageCheck == 'English' ? 'head-text head-text-font' : 'head-text'" style="letter-spacing: 2px;">{{ languageJson.adminText }}</div>

		<div class="head-tap" v-if="type == 'index' && positionType == '1'" style="left: 22.5%;">
			<img src="../../static/imgV2/tap-left-1.png" alt="">
			<div :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">{{ languageJson.home }}</div>
		</div>

		<div class="head-tap" v-if="type != 'index' && positionType == '1'" style="left: 22.5%;" @mouseenter="leftImg = leftImg_1"
			@mouseleave="leftImg = leftImg_0" @click="goLink('customindex')">
			<img :src="leftImg" alt="">
			<div :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">{{ languageJson.home }}</div>
		</div>

		<div class="head-tap" v-if="type != 'admin'" style="right: 22.5%;" @mouseenter="rightImg = rightImg_1"
			@mouseleave="rightImg = rightImg_0" @click="goLink('admin')">
			<img :src="rightImg" alt="">
			<div :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">{{ languageJson.monitor }}</div>
		</div>

		<div class="head-tap" v-if="type == 'admin'" style="right: 22.5%;">
			<img :src="rightImg_1" alt="">
			<div @click="toIndex" :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">{{ languageJson.monitor }}</div>
		</div>

<!--    <div class="head-tap" v-if="type == 'admin'" style="right: 12%;">-->
<!--      <img :src="rightImg_1" alt="">-->
<!--      <div @click="toOilList" :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">油罐生产</div>-->
<!--    </div>-->

		<div class="head-tap" v-if="type != 'playback' && positionType == '1'" style="right: 12%;" @mouseenter="rightImg2 = rightImg_2"
			 @mouseleave="rightImg2 = rightImg0" @click="goLink('playback')">
			<img :src="rightImg2" alt="">
			<div :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' " >{{ languageJson.playback }}</div>
		</div>

		<div class="head-tap" v-if="type == 'playback' && positionType == '1'" style="right: 12%;">
			<img :src="rightImg_1" alt="">
			<div :class=" languageCheck == 'English' ? 'head-tap-div head-tap-div-font' : 'head-tap-div' ">{{ languageJson.playback }}</div>
		</div>
	</div>
</template>

<script>
	import {
		login,
		setLanguage
	} from '@/api/admin'
	import {
		environmentGetInfo
	} from '@/api/indexV2'
	import {
		setToken,
		setItem,
		removeItem,
		removeToken,
		getItem
	} from '@/utils/auth'
	export default {
		name: 'login',
		data() {
			return {
				loginTimer: null,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
        // who: localStorage.getItem('userInfo'),
				differtime: 0,
				cocoImg: require('../../static/imgV2/logo.png'),
				headImg: require('../../static/imgV2/head.png'),
				leftImg: require('../../static/imgV2/tap-left-0.png'),
				leftImg_0: require('../../static/imgV2/tap-left-0.png'),
				leftImg_1: require('../../static/imgV2/tap-left-1.png'),
				rightImg: require('../../static/imgV2/tap-right-0.png'),
        rightImg2: require('../../static/imgV2/tap-right-0.png'),
        rightImg0: require('../../static/imgV2/tap-right-0.png'),
				rightImg_0: require('../../static/imgV2/tap-right-0.png'),
				rightImg_1: require('../../static/imgV2/tap-right-1.png'),
        rightImg_2: require('../../static/imgV2/tap-right-1.png'),
				openImg: require('../../static/imgV2/fullScreen-0.png'),
				openImg_0: require('../../static/imgV2/fullScreen-0.png'),
				openImg_1: require('../../static/imgV2/fullScreen-1.png'),
				outImg: require('../../static/imgV2/close-0.png'),
				outImg_0: require('../../static/imgV2/close-0.png'),
				outImg_1: require('../../static/imgV2/close-1.png'),
				tapStatus: false,
				newTime: new Date(),
				closeImg: require('../../static/imgV2/quxiao.png'),
				cithData: {
					cityName: "",
					weather: ""
				},
				positionType: getItem('userInfo').positionType,
				screenHeight: document.body.clientHeight
			}
		},
		props: {
			type: String
		},
		mounted() {
      console.log(this.positionType)
      console.log(this.type)
			let that = this
			that.environmentGetInfo(getItem('tenantInfoId'))
			window.onresize = () => {
				that.screenHeight = document.body.clientHeight
			}
			that.loginTimer = setInterval(() => {
				that.newTime = new Date()
			}, 1000)
		},
		beforeDestroy() {
			let that = this
			if (that.loginTimer) {
				clearInterval(that.loginTimer)
				that.loginTimer = null
			}
		},
		methods: {
      toIndex(){
        this.$router.push({
          name: 'user'
        })
      },
      toOilList(){
        this.$router.push({
          name: 'oil'
        })
      },
			checkLanguage(type) {
				let langZh = ''
				if (type == 'English') {
					langZh = 'en_US'
				} else if (type == 'Traditional') {
					langZh = 'zh_HK'
				} else {
					langZh = 'zh_CN'
				}
				setLanguage(langZh).then(res => {
					setItem('language', type)
					location.reload()
				})
			},
			environmentGetInfo(tid) {
				let that = this
				environmentGetInfo(tid).then(res => {
					if (res) { that.cithData = res.data }
				})
			},
			goLink(type) {
				this.$router.push({ name: type })
			},
			out() {
				this.$emit('out',true)
			},
			fullScreenHandle() {
				var element = document.documentElement
				if (this.tapStatus) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					}
					this.tapStatus = !this.tapStatus
				} else {
					if (element.webkitRequestFullscreen) {
						element.webkitRequestFullscreen()
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen()
					} else if (element.mozRequestFullscreen) {
						element.mozRequestFullscreen()
					} else if (element.requestFullscreen) {
						element.requestFullscreen()
					}
					this.tapStatus = !this.tapStatus
				}
			}
		},
		watch: {
			screenHeight: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					if (screen.height == newData) {
						this.tapStatus = true
					} else {
						this.tapStatus = false
					}
				}
			},
			tapStatus: {
				deep: true,
				immediate: true,
				handler(newData, oldData) {
					this.$emit('tapStatus', newData)
				}
			}
		}
	}
</script>

<style>
	.popoverBackB {
		background: rgba(0, 15, 50, 0.95) !important;
		border: 1px solid rgba(0, 240, 255, 0.2) !important;
		padding: 0 !important;
		color: white;
		backdrop-filter: blur(10px);
	}
	.popoverBackB .popper__arrow::after {
		background: rgba(0, 15, 50, 0.95);
		border-bottom-color: rgba(0, 15, 50, 0.95) !important;
	}
	.el-popper .popper__arrow {
		display: none;
	}
</style>

<style scoped lang="less">
	.lenDom {
		padding: 0.3vw 0.5vw;
		font-size: 0.7vw;
		cursor: pointer;
		transition: all 0.3s ease;
		border-left: 2px solid transparent;

		&:hover {
			background: rgba(0, 240, 255, 0.1);
			border-left-color: #00f0ff;
		}
	}
	.lenDomCheck {
		background-color: rgba(0, 128, 255, 0.3);
		border-left-color: #00f0ff;
	}
	.headCss {
		width: 100%;
		z-index: 99;
		background: linear-gradient(180deg, rgba(0, 12, 50, 0.98) 0%, rgba(0, 8, 35, 0.95) 70%, rgba(0, 6, 25, 0.9) 100%);
		position: relative;
		border-bottom: 1px solid rgba(0, 240, 255, 0.2);
		box-shadow: 0 2px 20px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(0, 240, 255, 0.12);

		/* Bottom glow line */
		&::after {
			content: '';
			position: absolute;
			bottom: -1px;
			left: 5%;
			width: 90%;
			height: 2px;
			background: linear-gradient(90deg, transparent, rgba(0, 240, 255, 0.4) 20%, rgba(0, 128, 255, 0.6) 50%, rgba(0, 240, 255, 0.4) 80%, transparent);
			filter: blur(1px);
		}

		.head-tap {
			position: absolute;
			width: 12%;
			height: 90%;
			top: 0%;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 100%;
				transition: all 0.3s ease;
				filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.2));
			}

			&:hover img {
				filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.5));
			}

			.head-tap-div {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 80%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 1.3vw;
				font-weight: 800;
				color: #e0f0ff;
				cursor: pointer;
				text-shadow: 0 0 8px rgba(0, 240, 255, 0.3);
				letter-spacing: 2px;
				transition: all 0.3s ease;

				&:hover {
					color: #00f0ff;
					text-shadow: 0 0 12px rgba(0, 240, 255, 0.5);
				}
			}

			.head-tap-div-font {
				font-size: 1vw;
				height: 80%;
			}
		}

		.head-time {
			position: absolute;
			left: 30px;
			top: 0px;
			color: #c0e0ff;
			height: 70%;
			font-size: 1.2vw;
			font-weight: 700;
			display: flex;
			align-items: center;
			letter-spacing: 1px;
			animation: textGlow 4s ease-in-out infinite;
		}

		.head-out {
			position: absolute;
			right: 30px;
			top: 0px;
			height: 70%;
			display: flex;
			align-items: center;
			z-index: 99;

			.out-img {
				margin-left: 0.5vw;
				cursor: pointer;
				width: 2.5vw;
				height: 2.5vw;
				transition: all 0.3s ease;
				filter: drop-shadow(0 0 3px rgba(0, 240, 255, 0.2));

				&:hover {
					filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.5));
					transform: scale(1.1);
				}
			}

			.out-cloes {
				margin-left: 0.5vw;
				cursor: pointer;
				width: 2.5vw;
				height: 2.5vw;
				transition: all 0.3s ease;

				&:hover {
					filter: drop-shadow(0 0 6px rgba(255, 80, 80, 0.5));
					transform: scale(1.1);
				}
			}
		}

		.head-text {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 80%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-size: 2.1vw;
			font-weight: 900;
			font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
			letter-spacing: 8px;
			text-shadow: 0 0 15px rgba(0, 240, 255, 0.5), 0 0 30px rgba(0, 240, 255, 0.15);
			background: linear-gradient(180deg, #ffffff 10%, #80f0ff 45%, #0090ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			filter: drop-shadow(0 2px 10px rgba(0, 240, 255, 0.3));
		}
		.head-text-font {
			font-size: 1.2vw;
		}
	}

	@keyframes textGlow {
		0%, 100% { text-shadow: 0 0 5px rgba(0, 240, 255, 0.3); }
		50% { text-shadow: 0 0 10px rgba(0, 240, 255, 0.5), 0 0 20px rgba(0, 240, 255, 0.2); }
	}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue